/* eslint arrow-body-style: 0 */
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import usePromise from 'shared/src/hooks/usePromise';

import BigModal from 'web-react-ui/src/BigModal/BigModal';
import Menu from 'web-react-ui/src/components/collections/Menu';
import CancelButton from 'web-react-ui/src/components/elements/CancelButton';
import View from 'web-react-ui/src/components/layout/View';
import FormSubmit from 'web-react-ui/src/reactFinalForm/FormSubmit';
import SimpleForm from 'web-react-ui/src/reactFinalForm/SimpleForm';

import client from '../../../services/client';
import PlanEditForm from './PlanEditForm';

const PlanCreateModal = ({ property, history }) => {
  const [, isLoading, pipeline] = usePromise(
    () => {
      return client
        .properties.for(property.id)
        .plans.initialize();
    },
    [property],
    null,
    true
  );

  const goBack = useCallback(
    () => { history.push('./'); },
    [history]
  );

  const createPlan = useCallback(
    (formFields) => {
      return pipeline.save(formFields)
        .then((theSamePipeline) => {
          const { name, id } = theSamePipeline.getRemoteState().plan;
          return client
            .properties.for(property.id)
            .plans.for(id)
            .waitForIndex({
              searchArgs: { enabled: null, discoverable: null, name },
              onTimeout: () => { /* do nothing; it'll be indexed later */ }
            });
        })
        .then(goBack);
    },
    [pipeline, property]
  );

  const localState = pipeline && pipeline.getLocalState();
  const planSettingGroups = localState && localState.plan.settingGroups;

  return (
    <BigModal open={true}>
      <SimpleForm onSubmit={createPlan} initialValues={localState} loading={isLoading}>
        <BigModal.Contents>
          <BigModal.Header className='p1'>
            <div className='flex'>
              <h1>Add Partnership Plan</h1>
              <div className='mla'>
                <CancelButton onClick={goBack}/>
              </div>
            </div>
          </BigModal.Header>
          <BigModal.Body>
            <View>
              <View.Section narrow>
                <PlanEditForm settingGroups={planSettingGroups}/>
              </View.Section>
              <View.Section narrow>
                <Menu secondary>
                  <Menu.Item fitted primary position='right'>
                    <FormSubmit label='Create'/>
                  </Menu.Item>
                </Menu>
              </View.Section>
            </View>
          </BigModal.Body>
        </BigModal.Contents>
      </SimpleForm>
    </BigModal>
  );
};

PlanCreateModal.propTypes = {
  property: PropTypes.object,
  history: PropTypes.object
};

export default PlanCreateModal;
